import { Domain } from '@shared/app/scripts/services/domain';

/**
 * Http Intercept that sets with credentials for all requests to sibling domain
 */
export const WithCredentialsInterceptorProvider = {
  provide: 'withCredentialsInterceptor',
  deps: ['domain'],
  useFactory: (domain: Domain) => {
    return {
      /**
       * Adds withCredentials: true to all requests to sibling domains.
       * @param {ng.IHttpRequestConfigHeaders} config
       * config to be transformed
       * @return {ng.IHttpRequestConfigHeaders}
       * transformed config
       */
      request(
        config: ng.IHttpRequestConfigHeaders,
      ): ng.IHttpRequestConfigHeaders {
        if (domain.isSibling(config.url)) {
          config.withCredentials = true;
        }

        return config;
      },
    };
  },
};
